import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface Props {
  className?: string;
}

const AbcIcon = (props: Props) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="0 0 15 18">
      <g transform="matrix(1 0 0 1 -382 -4872 )">
        <path
          d="M 4.285714285714286 7.411764705882352  L 4.285714285714286 13.76470588235294  L 10.714285714285715 13.76470588235294  L 10.714285714285715 7.411764705882352  L 15 7.411764705882352  L 7.5 0  L 0 7.411764705882352  L 4.285714285714286 7.411764705882352  Z M 0 18  L 0 15.882352941176471  L 15 15.882352941176471  L 15 18  L 0 18  Z "
          fillRule="nonzero"
          fill="currentColor"
          stroke="none"
          transform="matrix(1 0 0 1 382 4872 )"
        />
      </g>
    </SvgIcon>
  );
};

export default AbcIcon;
